import { BidReceipt, Receipt } from '../graphql/indexer-graphql-types'

export const idComparer = (a: { id: string }, b: { id: string }): Boolean => a.id === b.id

export const mintComparer = (
  a: { mintObject: { id: string } },
  b: { mintObject: { id: string } }
): Boolean => a.mintObject.id === b.mintObject.id

export const ownerComparer = (a: { owner: string }, b: { owner: string }): Boolean =>
  a.owner === b.owner

export const tokenOwnerComparer = (a: { tokenOwner: string }, b: { tokenOwner: string }): Boolean =>
  a.tokenOwner === b.tokenOwner

export const receiptComparer = (a: Receipt, b: Receipt): Boolean =>
  a.seller === b.seller && a.buyer === b.buyer && a.mint === b.mint

export const bidReceiptComparer = (a: BidReceipt, b: BidReceipt): Boolean =>
  a.metadataObject?.mint === b.metadataObject?.mint &&
  a.buyer === b.buyer &&
  a.createdAtOnChain === b.createdAtOnChain
